export default function StatCard({ label, value, sublabel, accent = "#2A4D3E", icon: Icon, testid }) {
  return (
    <div
      className="bg-white border border-[#E8E6E1] rounded-2xl p-6 transition-all hover:shadow-[0_8px_30px_rgb(0,0,0,0.05)] hover:-translate-y-0.5 duration-200"
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div className="text-xs uppercase tracking-[0.12em] text-[#8E9992] font-semibold">{label}</div>
        {Icon && (
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${accent}14` }}>
            <Icon size={17} style={{ color: accent }} strokeWidth={1.6} />
          </div>
        )}
      </div>
      <div className="font-heading text-3xl font-semibold mt-3 text-[#2A332C] tracking-tight">{value}</div>
      {sublabel && <div className="text-xs text-[#5C6660] mt-1.5">{sublabel}</div>}
    </div>
  );
}
